import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AlertController } from "@ionic/angular";
import { ModalController } from "@ionic/angular";
import { FilterPage } from "../filter/filter.page";
import { Storage } from "@ionic/storage";
import { Helper } from "../services/Helper";
import { APIService } from "../services/APIService";
import {
  ToastController,
  LoadingController,
  MenuController,
  Platform,
} from "@ionic/angular";
import { Network } from "@ionic-native/network/ngx";
import{DoctorprofilePage} from '../doctorprofile/doctorprofile.page'
// import { InAppBrowserOptions } from "@ionic-native/in-app-browser/ngx";

declare let cordova: any;


@Component({
  selector: "app-home",
  templateUrl: "./home.page.html",
  styleUrls: ["./home.page.scss"],
})
export class HomePage  {

  deviceObj = [];
  type: string;

  slideOpts = {
    loop: false,
    slidesPerView: 1.5,
    spaceBetween: 30,
  };

  videoOptions = {
    loop: false,
    slidesPerView: 2,
    spaceBetween: 5,
  };

  cityId: any;
  loader: any;
  doctors: any;
  public items: any;
  public items1: any;
  hidetouch: any;
  patient:any;

  tokenData :any;
  firstname :any;
  lastname :any;
  email :any;
  phone :any;
  gender :any;
  dob :any;
  docprofilepicture:any;
  // options: InAppBrowserOptions = {
  //   zoom: "yes",
  //   fullscreen: "yes",
  //   hidenavigationbuttons: "yes",
  //   toolbar: "yes",
  //   hideurlbar: "yes",
  // };

  constructor(
    private alertCtrl: AlertController,
    private router: Router,
    private modalController: ModalController,
    private storage: Storage,
    public toastController: ToastController,
    private network: Network,
    public loadingController: LoadingController,
    public helper: Helper,
    private apiservice: APIService,
    private menuCtrl: MenuController,
    private platform: Platform,
    // private iab: InAppBrowser,
  ) {}

  ionViewWillEnter() {

    this.platform.backButton.subscribeWithPriority(1, () => {
      this.exitapp();
      
    });

    this.getAllDoctors(0);
    this.hidetouch = false;

  
  }


  async filter() {
    this.hidetouch = true;

    const modal = await this.modalController.create({
      component: FilterPage,
      cssClass: "model-class-for-home-filter",
    });
    modal.onDidDismiss().then((data) => {
      this.cityId = data["data"];
      this.getAllDoctors(this.cityId);
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data) {
      this.hidetouch = false;
    }
  }

  getAllDoctors(id) {
    if (!(this.network.type !== "none" && this.network.type !== "unknown")) {
      this.helper.presentToastError("Please on Internet Connection!");
    } else {
      this.presentLoading().then(() => {
        this.apiservice.getAllDoctors(id).subscribe(
          (response) => {
            this.doctors = response.body.result;
            this.items = this.doctors;

            console.log(this.doctors);
            this.dismissLoading();
          },
          (error) => {
            this.dismissLoading();
            this.helper.presentToastError("Something went wrong!");
          }
        );
      });
    }
  }

  book(docconsulting_fee, docId, docemail, docfirstname, docphone,docprofilepicture,doclastname,docspeciality,clinicaddress,clinicname,docqualification) {
    this.storage.set("docfee", docconsulting_fee);
    this.storage.set("_teamId", docId);
    this.storage.set("docEmail", docemail);
    this.storage.set("docfirstname", docfirstname);
    this.storage.set("docphone", docphone);
    this.storage.set("docprofilepicture", docprofilepicture);
    this.storage.set("doclastname", doclastname);
    this.storage.set("docspeciality", docspeciality);
    this.storage.set("clinicaddress", clinicaddress);
    this.storage.set("clinicname", clinicname);
    this.storage.set("docqualification", docqualification);
    console.log("docID", docId);
    console.log("last", docqualification);
    
    this.router.navigate(["/appointment-form"], {
      queryParams: { docId: docId },
    });
  }

  async presentModal() {
    const modal = await this.modalController.create({
      component: FilterPage,
      cssClass: "modal",
    });
    return await modal.present();
  }

  onSearchTerm(ev: CustomEvent) {
    this.items = this.doctors;
    const val = ev.detail.value;

    if (val && val.trim() !== "") {
      this.items = this.items.filter((term) => {
        return (
          term.clinicname.toLowerCase().indexOf(val.trim().toLowerCase()) >
            -1 ||
          term.docfirstname.toLowerCase().indexOf(val.trim().toLowerCase()) >
            -1 ||
          term.docspeciality.toLowerCase().indexOf(val.trim().toLowerCase()) >
            -1
        );
      });
    }
  }

  async presentLoading() {
    this.loader = await this.loadingController.create({
      translucent: true,
    });
    await this.loader.present();
  }

  async dismissLoading() {
    await this.loader.dismiss();
  }

  async exitapp() {
    this.dismissLoading();
    const me = this;
    const alert = await this.alertCtrl.create({
      header: "Exit App",
      message: "Are you sure you want to exit app?",
      buttons: [
        {
          text: "No",
          role: "no",
          handler: () => {},
        },
        {
          text: "Yes",
          handler: () => {
            (navigator as any).app.exitApp();
          },
        },
      ],
    });
    alert.style.cssText = "z-index: 50123;";
    await alert.present();
  }


  dismiss() {
    this. modalController.dismiss();
    }


    async openModal(doctor) {
      const modal = await this.modalController.create({
      
      component: DoctorprofilePage,
      componentProps: {doctor:doctor },
      cssClass: "model-class-for-home-image",
     
      });
      return await modal.present();
     }

     saveit(){
     // window.open('https://vkonnecthealth.com/terms.html')
     window.open('/assets/Policy Project/TermsOfServices.html' , '_system');
      }

      privacy(){
        // window.open('https://vkonnecthealth.com/privacy.html');
        window.open('/assets/Policy Project/Policy.html' , '_system');
      }

      Declaration(){
      
        window.open('/assets/Policy Project/Declarationn.html' , '_system');
       
      }
     
     aboutus(){
       window.open('/assets/Policy Project/mobileapp2.html' , '_system')
     }

     contactus(){
       window.open('/assets/Policy Project/mobileapp.html', '_system' )
     }
     
}


